<template>
    <div id="mainMap" v-if="mapSettings.position">
        <GmapMap
            :center="mapSettings.center"
            :zoom="10"
            :options="{
                   zoomControl: false,
                   mapTypeControl: false,
                   scaleControl: false,
                   streetViewControl: false,
                   rotateControl: false,
                   fullscreenControl: false,
                   disableDefaultUI: false,
                   gestureHandling: 'greedy'
                 }"
            map-type-id="terrain"
            style="width: 100%; height: 100%"
        >
            <GmapMarker
                :key="-1"
                :position="mapSettings.position"
                :clickable="true"
                @click="selectStore(mapSettings.position, -1)"
                :icon="{url: getStaticImage('icons/location/current_location.png'), scaledSize: {width: 20, height: 20, f: 'px', b: 'px'}  }"
            />
            <GmapMarker
                v-for="b in list"
                :key="b.business_id"
                :position="{lat: Number(b.lat), lng: Number(b.lon)}"
                :clickable="true"
                @click="selectStore({lat: Number(b.lat), lng: Number(b.lon)}, b.business_id)"
            />
        </GmapMap>
    </div>
</template>

<script>

    import {mapState} from "vuex";

    export default {
        name: "Map",
        methods: {
            selectStore(position, index) {
                this.mapSettings.center = position;
                if (index>-1){
                    this.mapSettings.selectedBusinessID = index;
                }
            }
        },
        computed: {
            ...mapState("businesses", ["list","mapSettings"])
        }
    }
</script>
